import { React, useState } from 'react';
import style from './../adminSect.module.scss';
import { CustomButton, CustomSearch } from './../../utils/Utils';
import Table from './Table';
import { ConferenceDataModal, ConferenceNewModal, SmallModal, EditConferenceModal } from '../../utils/Modals';
import axios from './../../../config/apiConfig';

const Conference = () => {
  const { sectHeader, usersTableHeader, headerTitle, headerHelpers, fullVH } = style;

  const [errorModalMsg, setErrorModalMsg] = useState({bol: false, msg: ''});
  const [page, setPage] = useState(1);
  const [givenPage, setGivenPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [conferences, setConferences] = useState([]);
  const [search, setSearch] = useState('');
  const [totalConferences, setTotalConferences] = useState(0);
  const [reqStatus, setReqStatus] = useState(false);

  // NEW CONFERENCE
  const [newConferenceModal, setNewConferenceModal] = useState(false);

  // SEE MORE DATA
  const [conferenceData, setConferenceData] = useState({});
  const [showMoreData, setShowMoreData] = useState(false);

  // EDIT DATA
  const [editConferenceModal, setEditConferenceModal] = useState(false);
  const [editingConference, setEditingConference] = useState({});

  // DEL DATA
  const [deleteConferenceModal, setDeleteConferenceModal] = useState(false);
  const [deletingConference, setDeletingConference] = useState({});

  const toggleModal = (set, state) => {
    set(!state);
  };

  const deleteConfirmed = async () => {
    try {
      const { data } = await axios.delete(`/conferences/${deletingConference._id}`);
      console.log(data); // eslint-disable-line
      setErrorModalMsg({bol: true, msg: 'Conferencia eliminada con exito', modal: () => {}});
      setConferences([]);
      setPage(1);
      getConferences();
      setDeleteConferenceModal(false);
      setShowMoreData(false);
    } catch (error) {
      setErrorModalMsg({bol: true, msg: 'Ocurrió un error al eliminar la conferencia intentelo de nuevo', modal: () => {}});
      console.log(error); // eslint-disable-line
    }
  };

  const newConference = async (values, speakerImg) => {
    try {
      values.image = speakerImg;
      const defLink = makeEmbedLink(values.youtubeLink);
      values.youtubeLink = `https://www.youtube.com/embed/${defLink}`;
      values.date = values.date.toDate();
      await axios.post('/conferences',values);
      setConferences([]);
      getConferences();
      setErrorModalMsg({bol: true, msg: 'Conferencia añadida con exito', modal: () => {}});
    } catch (error) {
      if (!error.response) {
        setErrorModalMsg({bol: true, msg: 'Ocurrió un error inesperado recargue la página por favor', modal: () => setNewConferenceModal(true)});
        return;
      }
      if (error.response.data.status[0].message === 'youtubeLink must be a valid URL') {
        setErrorModalMsg({bol: true, msg: 'El link de la conferencia no es valido', modal: () => setNewConferenceModal(true)});
      } else {
        setErrorModalMsg({bol: true, msg: 'Ocurrió un error inesperado recargue la página por favor', modal: () => setNewConferenceModal(true)});
      }
    }
  };
  
  const editConference = async (values, id, speakerImg) => {
    try {
      values.image = speakerImg;
      const defLink = makeEmbedLink(values.youtubeLink);
      values.youtubeLink = `https://www.youtube.com/embed/${defLink}`;
      values.date = values.date.toDate();
      await axios.put(`/conferences/${id}`,values);
      setConferences([]);
      getConferences();
      setErrorModalMsg({bol: true, msg: 'Conferencia editada con exito', modal: () => {}});
    } catch (error) {
      if (!error.response) {
        setErrorModalMsg({bol: true, msg: 'Ocurrió un error inesperado recargue la página por favor', modal: () => setEditConferenceModal(true)});
        return;
      }
      if (error.response.data.status[0].message === 'youtubeLink must be a valid URL') {
        setErrorModalMsg({bol: true, msg: 'El link de la conferencia no es valido', modal: () => setEditConferenceModal(true)});
      } else {
        setErrorModalMsg({bol: true, msg: 'Ocurrió un error inesperado recargue la página por favor', modal: () => setEditConferenceModal(true)});
      }
    }
  };

  const getConferences = async () => {
    try {
      setConferences([]);
      setReqStatus(false);
      const filter = search.inputSearch ? `&name=${search.inputSearch}` : '';
      const { data } = await axios.get(`/conferences?page=${page}${filter}`);
      setGivenPage(data.data[0].page);
      setTotalPages(data.data[0].totalPages);
      setConferences(data.data[0].conferences);
      setTotalConferences(data.data[0].totalConferences);
      setReqStatus(true);
    } catch (error) {
      console.log(error); // eslint-disable-line
    }
  };

  const makeEmbedLink = (link) => {
    const findV = link.indexOf('v=');
    const findEmbed = link.indexOf('embed');
    if (findV === -1 ) {
      if (findEmbed === -1) {
        const id = link.split('youtu.be/');
        return id[1];
      } else {
        const id = link.split('embed/');
        return id[1];
      }
    }
    const id = link.split('v=');
    const noOtherParamsVer = id[1].split('?');
    const noOtherParamsVer2 = noOtherParamsVer[0].split('&');
    return noOtherParamsVer2[0];
  };

  const openEdit = (conf) => {
    setShowMoreData(false);
    setEditingConference(conf);
    setEditConferenceModal(true);
  };

  const deleteFromDataModal = (conf) => {
    setDeletingConference(conf);
    setDeleteConferenceModal(true);
  };

  return (
    <div className={fullVH}>
      <div className={`${sectHeader} ${usersTableHeader}`}>
        <div className={headerTitle}>
          <h1>
            <b>Conferencias</b>
          </h1>
        </div>
        <div className={`${headerHelpers} userTable_search`}>
          <CustomSearch setInput={setSearch} placeholder="Buscar por nombre"/>
          <CustomButton
            color="btnPrimary"
            content="AGREGAR CONFERENCIA"
            size="bg"
            onclick={() => toggleModal(setNewConferenceModal,newConferenceModal)}
          />
        </div>
      </div>

      <Table
        totalPages={totalPages}
        setTotalPages={setTotalPages}
        page={page}
        setPage={setPage}
        setConferenceData={setConferenceData}
        setShowMoreData={setShowMoreData}
        showMoreData={showMoreData}
        conferenceData={conferenceData}
        conferences={conferences}
        toggleModal={toggleModal}
        getConferences={getConferences}
        setEditingConference={setEditingConference}
        setEditConferenceModal={setEditConferenceModal}
        editConferenceModal={editConferenceModal}
        deleteConferenceModal={deleteConferenceModal}
        setDeleteConferenceModal={setDeleteConferenceModal}
        setDeletingConference={setDeletingConference}
        setConferences={setConferences}
        givenPage={givenPage}
        totalConferences={totalConferences}
        reqStatus={reqStatus}
        search={search}
      />

      {showMoreData && (
        <ConferenceDataModal
          toggleModal={toggleModal}
          conferenceData={conferenceData}
          setShowMoreData={setShowMoreData}
          showMoreData={showMoreData}
          deleteFromDataModal={deleteFromDataModal}
          openEdit={openEdit}
          zIndex='1'
        />
      )}

      {newConferenceModal && (
        <ConferenceNewModal 
          toggleModal={toggleModal}
          setNewConferenceModal={setNewConferenceModal}
          newConferenceModal={newConferenceModal}
          newConference={newConference}
        />
      )}

      {editConferenceModal && (
        <EditConferenceModal 
          toggleModal={toggleModal}
          editConferenceModal={editConferenceModal}
          setEditConferenceModal={setEditConferenceModal}
          editingConference={editingConference}
          editConference={editConference}
        />
      )}

      <SmallModal
        title={errorModalMsg.msg}
        toggle={toggleModal}
        state={errorModalMsg.bol}
        set={setErrorModalMsg}
        reOpenModal={errorModalMsg.modal}
        secondBtn={{
          color: 'btnPrimary',
          content: 'Cerrar',
          onclick: () => {errorModalMsg.modal();setErrorModalMsg({bol: false, msg:''});},
        }}
      />

      <SmallModal
        title="¿Seguro que quiere eliminar la conferencia?"
        toggle={toggleModal}
        state={deleteConferenceModal}
        set={setDeleteConferenceModal}
        howManyBtn="2"
        zIndex='2'
        firstBtn={{
          color: 'btnOrange',
          content: 'Cerrar',
          onclick: () =>
            toggleModal(setDeleteConferenceModal, deleteConferenceModal),
        }}
        secondBtn={{
          color: 'btnOutline',
          content: 'Eliminar',
          onclick: deleteConfirmed,
        }}
      />

    </div>
  );
};

export default Conference;
